export const getCustomer = (state) => state.config.customer;
export const getScreen = (state) => state.config.screen;
export const getLocal = (state) => state.config.local;
export const getLocation = (state) => state.config.location;
export const getAffiches = (state) => state.data.affiches;
